
// import thermioBackground from '../Assets/rfback.png';
import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Image, Badge, ProgressBar } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';

import "../Styles/ThermiQRFStyle.css";
import thermioHeroImage from '../Assets/rfdevice.png';

import thermioNeedles from '../Assets/rfneedles.png';
import thermioBeforeAfter from '../Assets/rfbefore.png';
import thermioVacuum from '../Assets/rfvacum.png';
import thermioInsulation from '../Assets/rfinsulation.png';

const ThermioRFPage = () => {
  const [activeTab, setActiveTab] = useState('vacuum');
  const [energyLevel, setEnergyLevel] = useState(30);
  const [needleDepth, setNeedleDepth] = useState(2.0);
  const [isDragging, setIsDragging] = useState(false);
  const comparisonRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: false,
      mirror: true
    });
  }, []);

   const handleOpenPDF = () => {
  // Using fetch to get the file as blob
  fetch("https://romanqadir.github.io/jsonapi/rf.pdf")
    .then(response => response.blob())
    .then(blob => {
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'thermiQ-RF.pdf'; // Specify the filename for download
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Download failed:', error);
      // Fallback to opening in new tab if download fails
      window.open("https://romanqadir.github.io/jsonapi/rf.pdf", '_blank');
    });
};

 
  // Needle configurations
  const needleOptions = [
    {
      pins: 10,
      depth: "0.1-4.0mm",
      applications: ["Around Eyes", "Nose Area", "Fine Wrinkles"],
      icon: "fas fa-eye",
      color: "#FF6B6B"
    },
    {
      pins: 25,
      depth: "0.1-4.0mm",
      applications: ["Cheeks", "Forehead", "Facial Rejuvenation"],
      icon: "fas fa-user",
      color: "#4ECDC4"
    },
    {
      pins: 64,
      depth: "0.1-4.0mm",
      applications: ["Neck", "Body", "Deep Collagen Stimulation"],
      icon: "fas fa-expand",
      color: "#FFD166"
    },
    {
      pins: "10/25",
      depth: "0.1-8.0mm",
      applications: ["Targeted Areas", "Medium Coverage"],
      icon: "fas fa-bullseye",
      color: "#95E1D3"
    }
  ];

  // Treatment protocols from PDF
  const treatmentProtocols = [
    {
      pulseWidth: "0.4ms",
      needleLength: "1.8mm",
      speed: "4ms",
      energy: "30mj",
      sessions: "3 sessions",
      times: "2 times"
    },
    {
      pulseWidth: "0.6ms",
      needleLength: "2.4mm",
      speed: "0.6ms",
      energy: "40mj",
      sessions: "3 sessions",
      times: "2 times"
    },
    {
      pulseWidth: "0.3ms",
      needleLength: "2.0mm",
      speed: "5ms",
      energy: "40mj",
      sessions: "3 sessions",
      times: "2 times"
    },
    {
      pulseWidth: "0.4ms",
      needleLength: "1.8mm",
      speed: "5ms",
      energy: "40mj",
      sessions: "3 sessions",
      times: "2 times"
    }
  ];

  // Technology features
  const techFeatures = [
    {
      title: "Deep Precision Technology",
      description: "8mm needle penetration for superior collagen remodeling",
      icon: "fas fa-bullseye",
      detail: "Reaches deep dermal layers for remarkable skin-firming effects",
      color: "#FF6B6B"
    },
    {
      title: "0.23mm Microneedles",
      description: "Minimizes tissue damage and promotes faster healing",
      icon: "fas fa-syringe",
      detail: "Smaller wounds for reduced downtime and comfortable recovery",
      color: "#4ECDC4"
    },
    {
      title: "Insulation Coating",
      description: "Concentrates RF energy at needle tip only",
      icon: "fas fa-shield-alt",
      detail: "Prevents surface burns while ensuring deep energy delivery",
      color: "#FFD166"
    }
  ];

  // Treatment results
  const treatmentResults = [
    { concern: "Wrinkles Reduction", improvement: 85, color: "#FF6B6B" },
    { concern: "Skin Tightening", improvement: 90, color: "#4ECDC4" },
    { concern: "Acne Scar Repair", improvement: 80, color: "#FFD166" },
    { concern: "Pore Minimization", improvement: 75, color: "#95E1D3" },
    { concern: "Stretch Marks", improvement: 70, color: "#667eea" },
    { concern: "Skin Elasticity", improvement: 85, color: "#764ba2" }
  ];

  // Handle mouse move for comparison slider
  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !comparisonRef.current) return;
    
    const rect = comparisonRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = Math.min(Math.max((x / rect.width) * 100, 0), 100);
    
    const beforeImage = comparisonRef.current.querySelector('.before-image');
    const sliderHandle = comparisonRef.current.querySelector('.slider-handle');
    
    if (beforeImage) beforeImage.style.width = `${percentage}%`;
    if (sliderHandle) sliderHandle.style.left = `${percentage}%`;
  };

  // Initialize comparison slider on mount
  useEffect(() => {
    const handleGlobalMouseUp = () => setIsDragging(false);
    window.addEventListener('mouseup', handleGlobalMouseUp);
    return () => window.removeEventListener('mouseup', handleGlobalMouseUp);
  }, []);

  return (
    <div className="thermio-product-page">
      {/* Hero Section with Advanced Particles */}
      <section className="thermio-hero-section">
        {/* Animated Background Particles */}
        <div className="particles-container">
          {[...Array(50)].map((_, i) => (
            <div 
              key={i} 
              className="particle" 
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                width: `${Math.random() * 4 + 2}px`,
                height: `${Math.random() * 4 + 2}px`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${Math.random() * 3 + 2}s`,
                background: i % 3 === 0 ? '#FF6B6B' : i % 3 === 1 ? '#FF8E53' : '#FE5D26'
              }}
            />
          ))}
        </div>
        
        <Container>
          <Row className="align-items-center min-vh-100">
            <Col lg={6} className="hero-content" data-aos="fade-right">
              <Badge bg="light" text="dark" className="mb-3 pulse-badge" data-aos="fade-up">
                <i className="fas fa-bolt me-2"></i>
                Advanced RF Technology
              </Badge>
              
              <h1 className="product-title animate-charcter-thermio">
                EPILYUM THERMIQ
              </h1>
              <h2 className="product-subtitle typed-text">
                Microneedling + Multipolar RF
              </h2>
              
              <p className="hero-tagline" data-aos="fade-up" data-aos-delay="200">
                Diversified treatment options, excellent results with minimal downtime
              </p>
              
              <div className="hero-features" data-aos="fade-up" data-aos-delay="300">
                <div className="feature-chip">
                  <i className="fas fa-syringe"></i>
                  <span>0.23mm Precision</span>
                </div>
                <div className="feature-chip">
                  <i className="fas fa-layer-group"></i>
                  <span>Up to 8mm Depth</span>
                </div>
                <div className="feature-chip">
                  <i className="fas fa-shield-alt"></i>
                  <span>Insulated Needles</span>
                </div>
              </div>
            </Col>
            
            <Col lg={6} className="text-center" data-aos="fade-left" data-aos-delay="400">
              <div className="device-glow-container">
                {/* Glow Effects */}
                <div className="glow-effect glow-1"></div>
                <div className="glow-effect glow-2"></div>
                <div className="glow-effect glow-3"></div>
                
                {/* Device Image */}
                <Image 
                  src={thermioHeroImage} 
                  fluid 
                  className="product-hero-image thermio-hologram" 
                  alt="ThermiQ Microneedling RF Device"
                />
                
                {/* Energy Waves */}
                <div className="energy-field">
                  <div className="energy-wave"></div>
                  <div className="energy-wave delay-1"></div>
                  <div className="energy-wave delay-2"></div>
                </div>
              </div>
              
              {/* Device Specifications */}
              <div className="device-specs" data-aos="fade-up" data-aos-delay="600">
                <div className="spec-card">
                  <i className="fas fa-ruler-vertical"></i>
                  <div>
                    <span className="spec-value">0.1-8.0mm</span>
                    <span className="spec-label">Needle Depth</span>
                  </div>
                </div>
                <div className="spec-card">
                  <i className="fas fa-tachometer-alt"></i>
                  <div>
                    <span className="spec-value">2MHZ</span>
                    <span className="spec-label">RF Frequency</span>
                  </div>
                </div>
                <div className="spec-card">
                  <i className="fas fa-expand-arrows-alt"></i>
                  <div>
                    <span className="spec-value">12.1"</span>
                    <span className="spec-label">Touch Screen</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        
        {/* Scroll Indicator */}
        <div className="scroll-indicator" data-aos="fade-up" data-aos-delay="800">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
          <div className="arrows">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </section>

      {/* Technology Introduction */}
      <section className="tech-reveal-section py-6">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <div className="section-header" data-aos="fade-up">
                <div className="tech-icon mb-4" data-aos="zoom-in">
                  <i className="fas fa-microchip"></i>
                </div>
                <h2 className="section-title thermio-title mb-4" style={{color:'white'}}>
                  Revolutionary <span className="text-highlight">Dual Technology</span>
                </h2>
                <p className="intro-text thermio-description" style={{color:'white'}}>
                  ThermiQ Microneedling RF combines precise microneedling with radiofrequency 
                  energy to create microchannels while delivering controlled heat deep into 
                  the dermis, stimulating collagen and elastin production for comprehensive 
                  skin rejuvenation.
                </p>
              </div>
            </Col>
          </Row>
          
          {/* 3D Flip Cards */}
          <Row className="g-4 mt-6">
            {techFeatures.map((feature, index) => (
              <Col lg={4} key={index} data-aos="flip-up" data-aos-delay={index * 200}>
                <div className="tech-card-3d" style={{ '--card-color': feature.color }}>
                  <div className="card-front">
                    <div className="card-icon">
                      <i className={feature.icon}></i>
                    </div>
                    <h4>{feature.title}</h4>
                    <p>{feature.description}</p>
                  </div>
                  <div className="card-back">
                    <p>{feature.detail}</p>
                    <div className="tech-sparkle">
                      <i className="fas fa-sparkles"></i>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Needle System with Interactive Tabs */}
      <section className="needle-system-section py-6 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title thermio-title" data-aos="fade-up">
                Advanced <span className="text-highlight">Needle System</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          {/* Tab Navigation */}
          <Row className="mb-5">
            <Col lg={12}>
              <div className="handle-tabs" data-aos="fade-up">
                <button 
                  className={`handle-tab ${activeTab === 'vacuum' ? 'active' : ''}`}
                  onClick={() => setActiveTab('vacuum')}
                >
                  <i className="fas fa-wind me-2"></i>
                  Vacuum Suction Handle
                </button>
                <button style={{color:'grey'}}
                  className={`handle-tab ${activeTab === 'standard' ? 'active' : 'white'}`}
                  onClick={() => setActiveTab('standard')}
                >
                  <i className="fas fa-tachometer-alt me-2"></i>
                  Standard Handle
                </button>
              </div>
            </Col>
          </Row>
          
          {/* Tab Content */}
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="handle-visualization">
                {activeTab === 'vacuum' ? (
                  <Image 
                    src={thermioVacuum} 
                    fluid 
                    className="handle-image floating-3d" 
                    alt="Vacuum Suction Handle"
                  />
                ) : (
                  <Image 
                    src={thermioNeedles} 
                    fluid 
                    className="handle-image floating-3d" 
                    alt="Standard Handle"
                  />
                )}
                
                {/* Vacuum Effect Animation */}
                <div className="vacuum-effect" style={{ opacity: activeTab === 'vacuum' ? 1 : 0 }}>
                  <div className="vacuum-ring"></div>
                  <div className="vacuum-ring delay-1"></div>
                  <div className="vacuum-ring delay-2"></div>
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <div className="handle-info">
                <h3 className="mb-4">
                  {activeTab === 'vacuum' ? 'Vacuum-Assisted Technology' : 'Precision Needle System'}
                </h3>
                
                <p className="mb-4">
                  {activeTab === 'vacuum' 
                    ? 'Advanced vacuum-assisted adsorption stabilizes skin, ensures uniform penetration, and minimizes discomfort with automatic needle retraction.'
                    : 'Ultra-fine 0.23mm microneedles create precise micro-injuries with minimal trauma and rapid healing.'}
                </p>
                
                <div className="handle-specs">
                  <div className="spec-item">
                    <i className="fas fa-ruler-combined"></i>
                    <span>Depth: {activeTab === 'vacuum' ? '0.1-4.0mm' : '0.1-8.0mm'}</span>
                  </div>
                  <div className="spec-item">
                    <i className="fas fa-syringe"></i>
                    <span>Needle: 0.23mm diameter</span>
                  </div>
                  <div className="spec-item">
                    <i className="fas fa-bolt"></i>
                    <span>RF Energy: Concentrated tip</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          
          {/* Needle Options Grid */}
     
        </Container>
      </section>

      {/* Insulation Technology */}
      <section className="insulation-section py-6">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="insulation-visual">
                <Image 
                  src={thermioInsulation} 
                  fluid 
                  className="insulation-image" 
                  alt="Insulation Coating Technology"
                />
                <div className="energy-flow">
                  <div className="energy-line"></div>
                  <div className="energy-line delay-1"></div>
                  <div className="energy-line delay-2"></div>
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <h2 className="section-title thermio-title mb-4" style={{color:'white'}}>
                Intelligent <span className="text-highlight">Insulation Coating</span>
              </h2>
              <div className="divider mb-4"></div>
              
              <p className="mb-4" style={{color:'white'}}>
                Each needle features specialized insulation coating that concentrates RF energy 
                exclusively at the needle tip while shielding the surrounding skin from thermal 
                exposure. This prevents surface burns while ensuring deep, accurate energy 
                delivery for optimal collagen remodeling.
              </p>
              
              <div className="insulation-benefits" style={{color:'white'}}>
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="fas fa-bullseye"></i>
                  </div>
                  <div >
                    <h5 >Precise Energy Delivery</h5>
                    <p>RF energy concentrated at needle tip only</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="fas fa-shield-alt"></i>
                  </div>
                  <div>
                    <h5>Surface Protection</h5>
                    <p>Prevents burns and epidermal damage</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <i className="fas fa-heartbeat"></i>
                  </div>
                  <div>
                    <h5>Enhanced Comfort</h5>
                    <p>Safer and more comfortable treatment experience</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Interactive Treatment Simulator */}
      <section className="simulator-section py-6 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title thermio-title" data-aos="fade-up">
                Treatment <span className="text-highlight">Parameter Simulator</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="simulator-container" data-aos="fade-up">
                <div className="simulator-visual">
                  <div className="skin-layers">
                    <div className="layer hypodermis">Epidermis</div>
                    <div className="layer dermis">Dermis</div>
                    <div className="layer epidermis ">Hypodermis</div>
                    
                    {/* Needle Indicator */}
                    <div 
                      className="needle-indicator" 
                      style={{ height: `${(needleDepth / 8) * 100}%` }}
                    >
                      <div 
                        className="needle-tip" 
                        style={{ 
                          background: `radial-gradient(circle, #FF6B6B, rgba(255, 107, 107, ${energyLevel / 100}))`
                        }}
                      >
                        <div className="energy-pulse"></div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="simulator-controls">
                  <div className="control-group">
                    <label>
                      <i className="fas fa-ruler-vertical me-2"></i>
                      Needle Depth: {needleDepth}mm
                    </label>
                    <input 
                      type="range" 
                      min="0.1" 
                      max="8.0" 
                      step="0.1"
                      value={needleDepth}
                      onChange={(e) => setNeedleDepth(parseFloat(e.target.value))}
                      className="form-range"
                    />
                  </div>
                  
                  <div className="control-group">
                    <label>
                      <i className="fas fa-bolt me-2"></i>
                      RF Energy: {energyLevel}mj
                    </label>
                    <input 
                      type="range" 
                      min="10" 
                      max="50" 
                      step="1"
                      value={energyLevel}
                      onChange={(e) => setEnergyLevel(parseInt(e.target.value))}
                      className="form-range"
                    />
                  </div>
                  
                  <div className="current-settings">
                    <div className="setting-item">
                      <span>Pulse Width:</span>
                      <span>0.4ms</span>
                    </div>
                    <div className="setting-item">
                      <span>Speed:</span>
                      <span>4ms</span>
                    </div>
                    <div className="setting-item">
                      <span>Sessions:</span>
                      <span>3 sessions × 2 times</span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <br></br>
      </section>

      {/* Interactive Before/After Comparison */}
      <section className="comparison-section py-6">
        <Container>
          
          <Row>
            <Col lg={12}>
              <div 
                className="comparison-container"
                ref={comparisonRef}
                onMouseMove={handleMouseMove}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
                data-aos="zoom-in"
              >
                <div className="comparison-wrapper">
                  {/* Before Image */}
                  <div className="image-container before-image">
                    <div className="image-overlay">
                      <span className="image-label">Before Treatment</span>
                    </div>
                  </div>
                  
                  {/* After Image */}
                  <div className="image-container after-image">
                    <div className="image-overlay">
                      <span className="image-label">After Treatment</span>
                    </div>
                  </div>
                  
                  {/* Slider Handle */}
                  <div className="slider-handle">
                    <i className="fas fa-arrows-alt-h"></i>
                  </div>
                </div>
              </div>
          
            </Col>
          </Row>
        </Container>
        <br></br>
      </section>

      {/* Treatment Protocols */}
      <section className="protocols-section py-6 bg-light">
        {/* <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title thermio-title" data-aos="fade-up">
                Recommended <span className="text-highlight">Treatment Protocols</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            {treatmentProtocols.map((protocol, index) => (
              <Col md={6} lg={3} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="protocol-card">
                  <div className="protocol-header">
                    <i className="fas fa-prescription"></i>
                    <h5>Protocol {index + 1}</h5>
                  </div>
                  <div className="protocol-body">
                    <div className="protocol-param">
                      <span className="param-label">Pulse Width:</span>
                      <span className="param-value">{protocol.pulseWidth}</span>
                    </div>
                    <div className="protocol-param">
                      <span className="param-label">Needle Length:</span>
                      <span className="param-value">{protocol.needleLength}</span>
                    </div>
                    <div className="protocol-param">
                      <span className="param-label">Speed:</span>
                      <span className="param-value">{protocol.speed}</span>
                    </div>
                    <div className="protocol-param">
                      <span className="param-label">Energy:</span>
                      <span className="param-value">{protocol.energy}</span>
                    </div>
                    <div className="protocol-sessions">
                      <i className="fas fa-calendar-alt me-2"></i>
                      {protocol.sessions} × {protocol.times}
                    </div>
                  </div>
                  <div className="protocol-footer">
                    <span className="protocol-indicator"></span>
                    <span>Recommended</span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container> */}
      </section>

      {/* Interactive Catalog */}
      <section className="catalog-section py-6">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center" data-aos="fade-up">
              <h2 className="section-title thermio-title mb-4">
                Interactive <span className="text-highlight">Product Catalogue</span>
              </h2>
              <div className="divider mb-5"></div>
              
              <div className="catalog-preview" data-aos="zoom-in">
                <div className="catalog-3d-preview">
                  <div className="catalog-cover">
                    <div className="cover-glow"></div>
                    <div className="cover-content">
                      <h3>EPILYUM THERMIQ</h3>
                      <p>Microneedling RF System</p>
                      <div className="cover-features">
                        <span><i className="fas fa-check"></i> 2MHZ RF</span>
                        <span><i className="fas fa-check"></i> 0.23mm Needles</span>
                        <span><i className="fas fa-check"></i> 8mm Depth</span>
                      </div>
                    </div>
                  </div>
                  <div className="catalog-pages">
                    {[1, 2, 3, 4].map(page => (
                      <div key={page} className="catalog-page"></div>
                    ))}
                  </div>
                </div>
                
                <div className="catalog-cta mt-5">
                  <button 
                    onClick={handleOpenPDF}
                    className="btn btn-primary btn-lg download-btn glow-button"
                    data-aos="fade-up"
                  >
                    <i className="fas fa-download me-2"></i>
                    Download Complete Catalogue
                    <div className="button-glow"></div>
                  </button>
                  
                  <p className="mt-3 text-muted" data-aos="fade-up" data-aos-delay="200">
                    <small>Includes technical specifications, treatment protocols, and safety guidelines</small>
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Safety Warning */}
      <section className="safety-warning py-4">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="warning-card" data-aos="fade-up">
                <div className="warning-header">
                  <i className="fas fa-exclamation-triangle"></i>
                  <h5>Important Safety Notice</h5>
                </div>
                <div className="warning-body">
                  <p>
                    RF Microneedling devices are intended solely for use by qualified physicians 
                    or practitioners trained in radiofrequency microneedling technology. Incorrect 
                    settings or misuse may cause serious injury including pigmentation changes, 
                    infection, or scarring. Always follow manufacturer guidelines.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default ThermioRFPage;